import { useCallback } from 'react';
export default function useFocusing({
  onBlur,
  onFocus
}) {
  const handleContainerBlur = useCallback(event => {
    onBlur(event);
  }, [onBlur]);
  const handleContainerFocus = useCallback(event => {
    onFocus(event);
  }, [onFocus]);
  return {
    handleContainerBlur,
    handleContainerFocus
  };
}